import '@inovua/reactdatagrid-community/index.css'
import BuildingTable from "./BuildingTable";
import HoursTable from "./HoursTable";
import ArticlesTable from "./ArticlesTable";
import TotalTable from "./total/TotalTable";
import {useFormikContext} from "formik";
import HardwareTable from "./HardwareTable";
import HoursTotal from "./HoursTotal";

// The calculatie tab handler
const InputHoursTable = () => {
    const {values} = useFormikContext();

    const {service_form_project_hour_tariffs} = values
    if (!service_form_project_hour_tariffs) return <></>
    return <>
        <h4>Gebouwen</h4>
        <BuildingTable/>

        <h4>Uren</h4>
        <HoursTable/>

        <h4>Abonnementen</h4>
        <ArticlesTable/>

        <h4>Apparatuur</h4>
        <HardwareTable/>

        <h4>Prijsoverzicht</h4>
        <TotalTable/>

        <h4>Urenoverzicht</h4>
        <HoursTotal/>

    </>;
}


export default InputHoursTable